'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ToastrTypes = {
    success: 'success',
    danger: 'danger'
};

exports.default = ToastrTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastr-basic/lib/common/ToastrTypes.js
// module id = 46
// module chunks = 0